import httpClient from '@/services/http/httpClient'

// PARAMETERS
export const apiGetAdminGagParameters = (page = 1) => {
    return httpClient.get('admin/gag/parameters/', {
            params: {
                page
            }
        })
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiPatchAdminGagParameters = (paramName, paramValue, customizable) => {
    return httpClient.post('admin/gag/parameters/', {
            param_name: paramName,
            param_value: paramValue,
            customizable
        })
        .then(data => data)
        .catch(error => Promise.reject(error))
}

// REP MAT
export const apiGetAdminRepMatParameters = (page = 1) => {
    return httpClient.get('admin/gag/reparations/materials/', {
            params: {
                page
            }
        })
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiPatchAdminRepMatParameters = (data) => {
    return httpClient.post('admin/gag/reparations/materials/update', data)
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiDeleteAdminRepMatParameters = (data) => {
    return httpClient.post('admin/gag/reparations/materials/delete', {
            data
        })
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiGetAdminRepTypes = () => {
    return httpClient.get('admin/gag/reparations/types/')
        .then(data => data)
        .catch(error => Promise.reject(error))
}

// ZIP CODES
export const apiGetAdminZipCodes = (page = 1, zip_code = null) => {
    return httpClient.get('admin/gag/zipcodes/', {
            params: {
                page,
                zip_code
            }
        })
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiPatchAdminZipCodes = (data) => {
    return httpClient.post('admin/gag/zipcodes/', data)
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiDeleteAdminZipCodes = (data) => {
    return httpClient.post('admin/gag/zipcodes/delete', { data })
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiGetCountries = () => {
    return httpClient.get('admin/gag/countries/')
        .then(data => data)
        .catch(error => Promise.reject(error))
}

// AJUSTAGE
export const apiGetAdminAjustage = (page = 1) => {
    return httpClient.get('admin/gag/ajustage/', {
            params: {
                page
            }
        })
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiPatchAdminAjustage = (data) => {
    return httpClient.post('admin/gag/ajustage/', data)
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiDeleteAdminAjustage = (data) => {
    return httpClient.post('admin/gag/ajustage/delete', { data })
        .then(data => data)
        .catch(error => Promise.reject(error))
}

// USER LIMITS
export const apiGetAdminUserLimits = (page = 1, company_id = null) => {
    return httpClient.get('admin/gag/userlimits/', {
            params: {
                page,
                company_id
            }
        })
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiPatchAdminUserLimits = (data) => {
    return httpClient.post('admin/gag/userlimits/', data)
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiDeleteAdminUserLimits = (data) => {
    return httpClient.post('admin/gag/userlimits/delete', { data })
        .then(data => data)
        .catch(error => Promise.reject(error))
}

// SALARIES
export const apiGetAdminSalaries = (page = 1, dept_code = null) => {
    return httpClient.get('admin/gag/salaries/', {
            params: {
                page,
                dept_code
            }
        })
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiPatchAdminSalaries = (data) => {
    return httpClient.post('admin/gag/salaries/', data)
        .then(data => data)
        .catch(error => Promise.reject(error))
}

export const apiDeleteAdminSalaries = (data) => {
    return httpClient.post('admin/gag/salaries/delete', { data })
        .then(data => data)
        .catch(error => Promise.reject(error))
}

// EXPORT TEMPLATE
export const apiGetAdminGAGTemplates = (tab_id) => { /* eslint-disable-line camelcase */
    return httpClient.get('admin/gag/templates/', {
            responseType: 'arraybuffer',
            params: {
                tab_id
            }
        })
        .then(data => data)
        .catch(error => Promise.reject(error))
}

// IMPORT TEMPLATE
export const apiPostAdminGAGTemplates = (file) => {
    const formData = new FormData()
    formData.append('file', file)

    return httpClient.post('admin/gag/templates/', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(data => data)
        .catch(error => Promise.reject(error))
}